/**
 * Other Material Component
 *
 * Displays generic files with download option.
 */

import { useTranslation } from 'react-i18next';
import { useMaterialUrl, type Material } from '@immopersian/common';
import { LoadingSpinner } from './shared/LoadingSpinner';
import { ErrorMessage } from './shared/ErrorMessage';
import { MaterialDescription } from './shared/MaterialDescription';
import { FileCard } from './shared/FileCard';
import { DocumentIcon } from './shared/Icons';

interface OtherMaterialProps {
  material: Material;
}

export function OtherMaterial({ material }: OtherMaterialProps) {
  const { t } = useTranslation();
  const { data, isLoading, error } = useMaterialUrl(material.id, material.type);

  if (isLoading) {
    return <LoadingSpinner message={t('courses.loadingFile')} />;
  }

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return (
    <>
      <MaterialDescription material={material} />
      <FileCard
        url={data?.url || ''}
        icon={<DocumentIcon />}
        label={t('courses.file')}
        openLabel={t('courses.open')}
      />
    </>
  );
}
